import Splitting from 'splitting'
import fonts from '../fonts.js'

export default function text (
  $el,
  { duplicates = 2, initialLineIndex = 0, space = false }
) {
  fonts.neutrifStudio.bold.load().then(() => {
    const results = Splitting({ target: $el, by: 'lines' })

    results.forEach(result => {
      result.words.forEach(word => {
        word.setAttribute('data-content', word.textContent)
      })

      result.lines.forEach((line, i) => {
        //   if (i % 2 !== 0) {
        //     line[0].style.marginLeft = 'auto'
        //   } else {
        //     line[0].style.marginLeft = 'auto'
        //     line[line.length - 1].style.marginRight = 'auto'
        //   }
        line.forEach(word => {
          let index = initialLineIndex + i
          word.classList.add(index % 2 ? 'line-odd' : 'line-even')
          word.classList.add(`line-${index}`)
          word.innerHTML = `<span>${word.innerHTML}</span>`
        })
        let content = line.reduce((acc, curr) => {
          return `${acc} ${curr.textContent}`.trim()
        }, '')

        let left = document.createElement('span')
        let right = document.createElement('span')
        //   left.className = right.className = 'absolute top-0 bottom-0 whitespace-pre pointer-events-none select-none'
        //   left.className += ' text-right right-full'
        //   right.className += ' left-full'
        left.innerHTML = repeatString(
          `${content} <span class="opacity-30">${content}</span>${
            space ? ' ' : ''
          }`,
          duplicates
        )
        right.innerHTML = repeatString(
          `${
            space ? ' ' : ''
          }<span class="opacity-30">${content}</span> ${content}`,
          duplicates
        )
        left.className = 'left'
        right.className = 'right'
        line[0].appendChild(left)
        line[line.length - 1].appendChild(right)
      })

      // $el.classList.add('is-ready')

      void $el.offsetWidth

      let observer = new window.IntersectionObserver(
        ([entry]) => {
          if (entry.intersectionRatio >= 0 && entry.isIntersecting) {
            observer.disconnect()
            window.setTimeout(() => {
              $el.classList.add('is-ready')
            }, 100)
          }
        },
        { threshold: 0 }
      )
      observer.observe($el)
    })
  })
}

// for IE support
function repeatString (string, times) {
  let repeatedString = ''
  while (times > 0) {
    repeatedString += string
    times--
  }
  return repeatedString
}



// WEBPACK FOOTER //
// ./src/js/components/text.js